import { render, staticRenderFns } from "./moreDCOU.vue?vue&type=template&id=2a726970&lang=pug&"
import script from "./moreDCOU.vue?vue&type=script&lang=js&"
export * from "./moreDCOU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports